<template>
  <div
    :id="id"
    class="c-modal modal"
    tabindex="0"
    style="
      z-index: 1003;
      display: none;
      opacity: 0;
      top: 4%;
      transform: scaleX(0.8) scaleY(0.8);
    "
  >
    <div class="c-modal--directions-title"><h2>Cupón</h2></div>
    <div class="c-modal--directions-body">
      <div class="c-input input-field">
        <input type="text" v-model="coupon" />
        <label for="">Nombre de cupón</label>
      </div>
    </div>
    <div class="c-modal__footer-buttons c-nav m-1">
      <button
        class="c-button c-button--primary c-button--width-fuid c-button--mobile-small waves-effect"
        @click="save"
      >
        Guardar
      </button>
      <button
        class="c-button c-button--width-fuid c-button--flat c-button--mobile-small waves-effect modal-close"
      >
        Cancelar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalCoupon",
  props: {
    id: String,
  },
  data() {
    return {
      coupon: null,
    };
  },
  methods: {
    async save() {
      this.showLoading();

      if (this.serviceType === 1 || this.serviceType === 3) {
        const payload = {
          coupon: this.coupon,
          serviceTypeId: this.serviceType,
          weight:
            this.serviceType === 3
              ? this.$store.getters.COMPRATRAE_ORDER_WEIGHT
              : null,
        };
        await this.$store
          .dispatch("GET_COUPON", payload)
          .then((success) => {
            this.$swal.close();
            if (success.status === 200) {
              this.$emit("getSelectedCoupon", success.data.result);
              this.coupon = "";
              this.closeModal(this.id);
            } else {
              this.showError(success.data.message);
              this.$emit("getSelectedCoupon", null);
            }
          })
          .catch((error) => {
            const msg = error?.data?.message || "Ocurrio un error.";
            this.showError(msg);
            this.$emit("getSelectedCoupon", null);
          });
      } else {
        let lstDestination = null;
        if (this.serviceType === 2) {
          lstDestination = this.$store.getters.PROGRAMMED_ORDER_DESTINATIONN;
        } else {
          lstDestination = this.$store.getters.SCHARFFPOINT_ORDER_DESTINATION;
        }
        const lstPeso = lstDestination.map((el) => el.packageSize.weight / 10);
        const payload = {
          coupon: this.coupon,
          serviceTypeId: this.serviceType,
          cantOrders: lstDestination.length,
          lstPeso,
        };
        await this.$store
          .dispatch("GET_COUPON_MULTI", payload)
          .then((success) => {
            this.$swal.close();
            if (success.status === 200) {
              this.$emit("getSelectedCoupon", success.data.result);
              this.coupon = "";
              this.closeModal(this.id);
            } else {
              this.showError(success.data.message);
              this.$emit("getSelectedCoupon", null);
            }
          })
          .catch((error) => {
            const msg = error?.data?.message || "Ocurrio un error.";
            this.showError(msg);
            this.$emit("getSelectedCoupon", null);
          });
      }
    },
  },
  computed: {
    serviceType() {
      return this.$store.getters.CURRENT_SERVICE;
    },
  },
};
</script>

<style></style>
